module.exports = __webpack_public_path__ + "img/yuedu.25f08122.png";